import { FieldConfig } from "../../../SetupFormGenerator";
import { COMPONENTLIST } from "../../../SetupFormGenerator/constants";
import {
  DecoratedMessageWithLinkDisplayType,
  DecoratedMessageWithLinkType,
} from "pages/employer-of-record/components/MessageWithLink/types";

export enum ReimbursementType {
  ACCOMMODATIONS = "Accommodations",
  MEALS_AND_ENTERTAINMENT = "Meals & entertainment",
  MILEAGE = "Mileage",
  PARKING = "Parking",
  PROFESSIONAL_DEVELOPMENT = "Professional development",
  TOOLS_AND_EQUIPMENT = "Tools & equipment",
  TRAVEL = "Travel",
  UNIFORMS = "Uniforms",
}

export const ReimbursementTypeMessage: {
  [key: string]: DecoratedMessageWithLinkType;
} = {
  [ReimbursementType.ACCOMMODATIONS]: {
    text: "Accommodations amounts will be treated as taxable reimbursements for accounting purposes. Payment to employees will be grossed up so they recover the full cost of the item.",
    displayType: DecoratedMessageWithLinkDisplayType.INFOALERT,
  },
  [ReimbursementType.MEALS_AND_ENTERTAINMENT]: {
    text: "Meals amounts will be treated as taxable reimbursements for accounting purposes. Payment to employees will be grossed up so they recover the full cost of the item.",
    displayType: DecoratedMessageWithLinkDisplayType.INFOALERT,
  },
  [ReimbursementType.MILEAGE]: {
    text: "Mileage amounts will be treated as taxable reimbursements for accounting purposes. Payment to employees will be grossed up so they recover the full cost of the item.",
    displayType: DecoratedMessageWithLinkDisplayType.INFOALERT,
  },
  [ReimbursementType.PARKING]: {
    text: "Parking amounts will be treated as taxable reimbursements for accounting purposes. Payment to employees will be grossed up so they recover the full cost of the item.",
    displayType: DecoratedMessageWithLinkDisplayType.INFOALERT,
  },
  [ReimbursementType.PROFESSIONAL_DEVELOPMENT]: {
    text: "Professional Development amounts will be treated as taxable reimbursements for accounting purposes. Payment to employees will be grossed up so they recover the full cost of the item.",
    displayType: DecoratedMessageWithLinkDisplayType.INFOALERT,
  },
  [ReimbursementType.TOOLS_AND_EQUIPMENT]: {
    text: "Tools & Equipment amounts will be treated as taxable reimbursements for accounting purposes. Payment to employees will be grossed up so they recover the full cost of the item.",
    displayType: DecoratedMessageWithLinkDisplayType.INFOALERT,
  },
  [ReimbursementType.TRAVEL]: {
    text: "Travel amounts will be treated as taxable reimbursements for accounting purposes. Payment to employees will be grossed up so they recover the full cost of the item.",
    displayType: DecoratedMessageWithLinkDisplayType.INFOALERT,
  },
  [ReimbursementType.UNIFORMS]: {
    text: "Uniforms amounts will be treated as taxable reimbursements for accounting purposes. Payment to employees will be grossed up so they recover the full cost of the item.",
    displayType: DecoratedMessageWithLinkDisplayType.INFOALERT,
  },
} as const;

export const EXPENSETYPES = Object.values(ReimbursementType);

export const EXPENSE_DETAILS_FIELDS: FieldConfig[] = [
  {
    label: "Transaction date",
    name: "transactionDate",
    type: COMPONENTLIST.DATE,
    required: true,
  },
  {
    label: "Distance",
    name: "distance",
    type: COMPONENTLIST.DISTANCEINPUT,
    required: true,
  },
  {
    label: "Receipt",
    name: "receipts",
    type: COMPONENTLIST.FILE,
    required: true,
    message: {
      text: "Include as many files as necessary. We can accept JPEG, PNG, or PDF up to 10 MB each.",
    },
  },
  {
    label: "Additional information",
    name: "additionalInformation",
    type: COMPONENTLIST.TEXTAREA,
    required: true,
    message: {
      text: "Describe the business purpose of the transaction. For meals, list everyone who attended the meal.",
    },
  },
];

export const PAYMENT_SETTINGS_FIELDS: FieldConfig[] = [
  {
    label: "Pay date",
    name: "payPeriodId",
    type: COMPONENTLIST.SELECT,
    options: [{ value: "", label: "" }],
    required: true,
  },
  {
    label: "Internal Notes",
    name: "notes",
    type: COMPONENTLIST.TEXTAREA,
    required: false,
    message: { text: "Only visible to admins" },
  },
];
